import * as $ from 'jquery';
import * as transformations from './transformations';

const transformer = function (): void {
    const $this: JQuery = $(this);
    const transform: any = $this.data('transform-on-blur');
    const fnTransform: Function = transformations[transform];
    if (fnTransform) {
        const value = $this.val();
        $this.val(fnTransform(value));
    }
};

$('[data-transform-on-blur]').on('blur', transformer);
